import {
    removeCognitoState,
    removeRedirectUrl,
    removeStoredAuthState,
    setAWSID,
    setCodeVerifier,
    setRedirectUrl,
    setStateParameter
} from "../util";

import { AuthLoginFailureAction, AuthLoginRequestAction, AuthLoginSuccessAction } from "../actions/AuthLogin";
import { AuthState } from "../state";

export function authLoginRequest(state: AuthState, action: AuthLoginRequestAction): AuthState {

    // clear out the Cognito stored states as they may cause issues when we go to authorize
    removeCognitoState();

    setAWSID(action.payload.awsId);
    setRedirectUrl(action.payload.moveTo);
    setStateParameter(action.payload.state);
    setCodeVerifier(action.payload.codeChallenge?.codeVerifier);

    console.log(`AuthLoginRequest: ${JSON.stringify(action.payload)}`);
    console.log(`redirectUrl: ${action.payload.moveTo}`);

    return {
        ...state,
        codeVerifier: action.payload.codeChallenge?.codeVerifier,
        isLoggingIn: true,
        redirectUrl: action.payload.moveTo,
        state: action.payload.state
    };
}

export function authLoginSuccess(state: AuthState, action: AuthLoginSuccessAction): AuthState {
    return { ...state, isLoggingIn: false, error: undefined };
}

export function authLoginFailure(state: AuthState, action: AuthLoginFailureAction): AuthState {
    removeStoredAuthState();
    removeRedirectUrl();
    return { ...state, isLoggingIn: false, error: action.payload.error, redirectUrl: undefined };
}
